<template>
  <div class="jiceng">
    <div class="title animate__animated wow animate__fadeInUp">
      <titleCard title="Local Infrastructure Development"></titleCard>
    </div>
    <div class="img1 animate__animated wow animate__fadeInUp">
      <img src="../../assets/image/innovatc/jiceng1.png" alt="" />
    </div>
    <h3 class="text animate__animated wow animate__fadeInUp">
      We are warmly to welcome you to our team, as one of our new business
      partners. Hope our cooperation will help greatly in the success of our
      future.
    </h3>
    <titleCard
      title="Business Operating Model"
      class="animate__animated wow animate__fadeInUp"
    ></titleCard>
    <div class="yunying-card animate__animated wow animate__fadeInUp">
      <div class="yunying-box">
        <img src="../../assets/image/innovatc/jiceng2.png" alt="" />
      </div>
    </div>
    <div class="quanyi animate__animated wow animate__fadeIn">
      <div class="top">
        <titleCard title="Rights and Interests"></titleCard>
      </div>
      <div class="content animate__animated wow animate__bounceIn">
        <h4>Grassroots <br>ecosystem</h4>
        <div class="bordericon left-top">
          <p style="text-align: right">
            Reduce medical<br />
            insurance expenses, <br />Hierarchic Care.
          </p>
          <div class="icon">
            <img src="@/assets/image/innovatc/icon1.webp" />
            <span>Governments</span>
          </div>
        </div>
        <div class="bordericon left-bootom">
          <p style="text-align: right">
            Improve the Patient Experience,<br />Reduce Medical Expenses
          </p>
          <div class="icon">
            <img src="@/assets/image/innovatc/icon2.webp" />
            <span>Patients</span>
          </div>
        </div>
        <div class="bordericon right-top">
          <div class="icon">
            <img src="@/assets/image/innovatc/icon3.webp" />
            <span>Hospitals</span>
          </div>
          <p>
            Discipline Construction to <br />Improve the Quality of Healthcare
          </p>
        </div>
        <div class="bordericon right-bottom">
          <div class="icon">
            <img src="@/assets/image/innovatc/icon4.webp" />
            <span>Companies </span>
          </div>
          <p>
            Grow the Brand,<br />
            Business Expansion
          </p>
        </div>
      </div>
    </div>
    <footerCard name="Mr Sun" phone="135-2108-4802"></footerCard>
  </div>
</template>

<script>
import footerCard from "../../components/footer-card.vue";
import titleCard from "../../components/title-card.vue";
export default {
  data() {
    return {};
  },
  components: {
    footerCard,
    titleCard,
  },
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
.jiceng {
  .title {
    margin: 1rem 0 0.7368rem 0;
    @media screen and (max-width: 540px) {
      margin: 33px 0;
    }
  }
  .img1 {
    height: 5.4947rem;
    padding: 0 2.2632rem;
    @media screen and (max-width: 540px) {
      padding: 0 0.5263rem;
      height: 6.3158rem;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
  .text {
    padding: 0.5263rem 2rem 0.9474rem 2rem;
    color: #0ca6eb;
    text-align: center;
    font-size: 0.4rem;
    margin: 0;
    @media screen and (max-width: 540px) {
      font-size: 16px;
      width: 68%;
      margin: 0 auto;
      padding: 34px 10px 50px 10px;
    }
  }
  .yunying-card {
    margin-top: 1.2632rem;
    justify-content: center;
    display: flex;
    p {
      font-size: 0.2947rem;
      width: 0.5947rem;
      text-align: center;
      padding-top: 1.0526rem;
      @media screen and (max-width: 540px) {
        font-size: 0.6316rem;
      }
    }
    .yunying-box {
      width: 8.9684rem;
      height: 5rem;
      margin-left: 0.6rem;
      margin-bottom: 1rem;
      @media screen and (max-width: 540px) {
        width: 80%;
        height: 200px;
      }
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  .text2 {
    color: #0ca6eb;
    font-size: 0.2947rem;
    text-align: center;
    font-weight: 500;
    margin: 0;
    padding: 0.4rem 0 0.8211rem 0;
    @media screen and (max-width: 540px) {
      font-size: 0.6316rem;
      font-weight: 600;
      padding: 19px 0;
    }
  }
  .quanyi {
    background-color: #fafafa;
    padding-bottom: 1.0526rem;
    overflow: hidden;
    @media screen and (max-width: 540px) {
      padding-bottom: 3.1579rem;
    }
    .top {
      padding: 1.0526rem 0;
      @media screen and (max-width: 540px) {
        padding: 70px 0;
      }
    }
    .content {
      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      height: 6.1474rem;
      width: 6.1474rem;
      @media screen and (max-width: 540px) {
        width: 200px;
        height: 200px;
      }
      background: url("../../assets/image/innovatc/ball.webp") no-repeat;
      background-size: 100% 100%;
      h4 {
        font-size: 0.2947rem;
        color: #333333;
        font-weight: 700;
        text-align: center;
        margin: 0;
      }
      .bordericon {
        display: flex;
        align-items: center;
        @media screen and (max-width: 540px) {
          width: 30%;
        }
        p {
          text-align: center;
          font-size: 0.2526rem;
          color: #272b2d;
          padding: 0 0.2947rem;
          @media screen and (max-width: 540px) {
            font-size: 12px;
          }
        }
        .icon {
          img {
            display: block;
            width: 0.6316rem;
            height: 0.6316rem;
            margin: 0 auto;
            margin-bottom: 0.0526rem;
          }
          span {
            display: block;
            width: 100%;
            text-align: center;
          }
          text-align: center;
          color: #0ca6eb;
          // width: 0.6316rem;
          font-size: 0.3158rem;
        }
      }
      .left-top {
        position: absolute;
        left: -66%;
        top: -10%;
        @media screen and (max-width: 540px) {
          left: -55%;
          top: -18%;
        }
      }
      .left-bootom {
        position: absolute;
        bottom: -5%;
        left: -82%;
        @media screen and (max-width: 540px) {
          bottom: -5%;
          left: -55%;
        }
      }
      .right-top {
        position: absolute;
        right: -83%;
        top: -10%;
        @media screen and (max-width: 540px) {
          right: -12%;
          top: -18%;
        }
        p {
          text-align: left;
        }
      }
      .right-bottom {
        position: absolute;
        bottom: -5%;
        right: -58%;
        @media screen and (max-width: 540px) {
          right: -12%;
          top: 65%;
        }
      }
    }
  }
}
</style>
